import React, { useState, useCallback, useEffect, useMemo, useContext, useRef } from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { injectIntl, intlShape } from 'react-intl';
import {AuthenticationContext} from '../AuthenticationContextProvider';
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import {ConfigContext} from '../ConfigContextProvider';

import {
  NavLink,
  Link
} from "react-router-dom";

const NavigationBar = (props) => {
  const [items, setItems] = useState(props.items);
  const history = useHistory();
  const location = useLocation();
  const { DOWNLOAD_URL } = useContext(ConfigContext);
  const {APPID} = useContext(ConfigContext);
  const {userOptions} = useContext(AuthenticationContext);

  // Gestione navigazione da tastiera - solo frecce, non Tab
  const handleKeyDown = useCallback((e) => {
    // Solo gestisco frecce e Home/End, non Tab
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
    
    // Verifica se siamo su un elemento di navigazione
    const activeElement = document.activeElement;
    if (!activeElement || !activeElement.id || !activeElement.id.startsWith('nav-')) return;

    const getCurrentLevelElements = () => {
      if (activeElement.id.startsWith('nav-primary-')) {
        return Array.from(document.querySelectorAll('[id^="nav-primary-"]'));
      } else if (activeElement.id.startsWith('nav-secondary-')) {
        return Array.from(document.querySelectorAll('[id^="nav-secondary-"]'));
      }
      // Rimuovo il caso nav-download- per escluderli dalla navigazione con frecce
      return [];
    };

    const elements = getCurrentLevelElements();
    if (elements.length === 0) return;

    const currentIndex = elements.indexOf(activeElement);
    if (currentIndex === -1) return;

    switch(e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : elements.length - 1;
        if (elements[prevIndex]) elements[prevIndex].focus();
        break;
      
      case 'ArrowRight':
        e.preventDefault();
        const nextIndex = currentIndex < elements.length - 1 ? currentIndex + 1 : 0;
        if (elements[nextIndex]) elements[nextIndex].focus();
        break;

      case 'Home':
        e.preventDefault();
        if (elements[0]) elements[0].focus();
        break;

      case 'End':
        e.preventDefault();
        if (elements[elements.length - 1]) elements[elements.length - 1].focus();
        break;
    }
  }, []);

  // Memorizza l'ID dell'elemento selezionato in sessionStorage
  const handleElementClick = useCallback((elementId) => {
    sessionStorage.setItem('navLastSelectedId', elementId);
  }, []);

  const handleFocus = useCallback(() => {
    // Non serve più tracciare il livello corrente
  }, []);

  // Aggiungi listener globale per la tastiera
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  // Ripristina il focus dopo la ricostruzione del menu
  useEffect(() => {
    const lastSelectedId = sessionStorage.getItem('navLastSelectedId');
    
    console.log('useEffect triggered:', { 
      lastSelectedId, 
      propsType: props.type,
      hasType: !!props.type 
    });
    
    if (!lastSelectedId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(lastSelectedId);
      if (element) {
        element.focus();
        console.log('Focus restored to:', lastSelectedId);
        // Pulisco il sessionStorage dopo aver ripristinato il focus
        sessionStorage.removeItem('navLastSelectedId');
      } else {
        console.log('Element not found:', lastSelectedId);
      }
    }, 200); // Timeout per aspettare che il DOM si aggiorni dopo il fetch

    return () => clearTimeout(timer);
  }, [props.type, props.category, props.order, location.pathname]); // Rimuovo lastSelectedId dalle dipendenze

  const downloadDetailHandler= useCallback((link, label, action) => {


    if(userOptions && Number(userOptions.login)) {

      let filename= link;
      let pos = String(link).lastIndexOf(".")
      let ext=  link.substr(pos+1);
      let filenameNoPath= link.substr(String(link).lastIndexOf("/")+1);



      if(window.mainunity && window.mainunity==="in" ) {
        filename = link.substring(0, pos);
        filename +="_in."+ link.substr(pos+1);
      }

      window.sendToGTM({
        event: "file_download",
        category: "3dlibrary",
        action: action,
        label: label,
        file_name: filenameNoPath,
        file_extension: ext
      })


      window.location.href= DOWNLOAD_URL + "?file="+ filename;
    } else {
      const event = new CustomEvent("login", {'detail': {APPID:APPID, fMode:"LOGIN", namespace:"modalAuth"} });
      document.dispatchEvent(event);
    }
  });
  
  const orderHandler= useCallback((e) => {
    const id=e.target.value;
    if(id && id != 0) { 
      history.push(`/${type.url}/${id}`);
    }
  });

  const categoryOrderHandler= useCallback((e) => {
    const id=e.target.value;
    if(id && id != 0) { 
      history.push(`/${type.url}/${category.url}/${id}`);
    }
  });

  const {type, category, order} = props;

  // Misura la larghezza della colonna download (destra) e la espone come
  // custom property, così la colonna sinistra può rispecchiarla via CSS
  const downloadsRef = useRef(null);
  const [sideWidth, setSideWidth] = useState(0);

  useEffect(() => {
    const el = downloadsRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() => {
      setSideWidth(el.offsetWidth);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <header className="navigation__header">
      <div className="navigation__wrapper">
        <>
          <div className="navigation__listWrapper">
            <ul className="navigation__list">
              { items.map((item, i) => {
                const elementId = `nav-primary-${item.url}`;
                const currentPath = location.pathname.split('/')[1];
                const isActive = item.url === currentPath;
                return (
                  <NavLink 
                    to={`/${item.url}`} 
                    key={`navlink_${i}`} 
                    id={elementId}
                    className={"navigation__link navigation__link--type"} 
                    activeClassName="active"
                    onFocus={handleFocus}
                    onClick={() => handleElementClick(elementId)}
                    tabIndex={isActive ? 0 : -1}
                  >
                    <FormattedMessage id={item.name} />
                  </NavLink>
                );
              })}
            </ul>
          </div>
          <div className="container">
          <div className="navigation__options" style={sideWidth ? { "--nav-side-width": `${sideWidth}px` } : undefined}>
            <div>
              {type && type.order && type.order.length >0 && 
                <div className="navigation__selectOrder">
                  <span className="selectOrder__label"><FormattedMessage id={"label.orderby"} /> </span>
                  <select className="selectOrder" value={order && order.url} onChange={ orderHandler}>
                    {type.order.map((item, i) => (
                      <option key={"option"+i} value={item.url} >{props.intl.formatMessage({id: item.name})}</option>
                    ))}
                  </select>
                </div>
              }

              {category && category.order && category.order.length >0 && 
                <div className="navigation__selectOrder">
                  <span className="selectOrder__label"><FormattedMessage id={"label.orderby"} /> </span>
                  <select className="selectOrder" value={order && order.url} onChange={ categoryOrderHandler}>
                    {category.order.map((item, i) => (
                      <option key={"option"+i} value={item.url} >{props.intl.formatMessage({id: item.name})}</option>
                    ))}
                  </select>
                </div>
              }
              
              </div>

            <div>
              {type && type.category && type.category.length >0 && <ul className="navigation__category">
                  {type.category.map((item, i) => {
                    const elementId = `nav-secondary-${type.url}-${item.url}`;
                    const pathParts = location.pathname.split('/');
                    const isActive = pathParts.length >= 3 && pathParts[1] === type.url && pathParts[2] === item.url;
                    return (
                      <NavLink 
                        to={`/${type.url}/${item.url}`} 
                        key={`catlink_${i}`} 
                        id={elementId}
                        className={"navigation__link"} 
                        activeClassName="active"
                        onFocus={handleFocus}
                        onClick={() => handleElementClick(elementId)}
                        tabIndex={isActive ? 0 : -1}
                      >
                        <FormattedMessage id={item.name} />
                      </NavLink>
                    );
                  })}
              </ul>}
            </div>
            <div ref={downloadsRef}>
              {<ul className="download__list">
                  {type && type.downloads && type.downloads.map((download, i) => {
                    const downloadId = `nav-download-${download.link.replace(/[^a-zA-Z0-9]/g, '-')}`;
                    return (
                      <li key={"download_link_"+i}>
                        <a 
                          id={downloadId}
                          className="download__link" 
                          onClick={(e) => {e.preventDefault(); downloadDetailHandler(download.link, props.intl.formatMessage({id: download.name}), "All") }}
                          onFocus={handleFocus}
                          tabIndex={0}
                        >
                          <span className="icon__download">
                            <svg width="13.981" height="18.286" viewBox="0 0 13.981 18.286"><g transform="translate(0 2)"><rect className="a" width="13.981" height="2.33" transform="translate(0 13.957)"/><path className="a" d="M21.847-61.3,20.2-62.944l-4.257,4.257v-9.869H13.765v9.869L9.508-62.944,7.866-61.3l6.991,6.991Z" transform="translate(-7.865 66.556)"/></g></svg>
                          </span>
                          <FormattedMessage id={download.name} />
                        </a>
                      </li>
                    );
                  })}
              </ul>}
            </div>
          </div>
          </div>
        </>
      </div>
    </header>
  );
}

export default injectIntl(NavigationBar);